import React, { useState, useImperativeHandle, forwardRef } from 'react';

const FloatingInput = forwardRef(({ label, type = 'text', required = false, bgType = "light", name, value, onChange }, ref) => {
    // const [value, setValue] = useState(value);
    // useImperativeHandle(ref, () => ({
    //     getValue: () => value,
    //     setValue: (newValue) => setValue(newValue),
    // }));

    return (
        <div className="form-floating mb-3">
            <input
                type={type}
                name={name}
                id={name}
                className="form-control"
                placeholder=" "
                value={value}
                // onChange={(e) => setValue(e.target.value)}
                onChange={onChange}
                required={required}
            />
            <label>{label}</label>

            <style>{`
                .form-floating > .form-control:focus ~ label::after,
                .form-floating > .form-control:not(:placeholder-shown) ~ label::after {
                    background-color: transparent;
                }
                .form-floating > .form-control:focus ~ label,
                .form-floating > .form-control:not(:placeholder-shown) ~ label {
                    color: ${bgType === 'dark' ? '#fff' : '#0C5546'};
                }
                input:-webkit-autofill {
                    box-shadow: 0 0 0px 1000px transparent inset !important;
                    -webkit-box-shadow: 0 0 0px 1000px transparent inset !important;
                    -webkit-text-fill-color: ${bgType === 'dark' ? '#fff' : 'black'} !important; /* Optional: set your desired text color */
                    transition: background-color 5000s ease-in-out 0s;
                }
            `}</style>
        </div>
    );
});

export default FloatingInput;
